/* istanbul ignore file */
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateGroupSetCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['minimumSize', codecNumber, 'minimum_size'],
    ['maximumSize', codecNumber, 'maximum_size'],
    ['id', /* #__PURE__ */ codecOptional(codecNumber)],
]);
export class CreateGroupSetCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateGroupSetCourseDataParser.decode(input).map(res => new CreateGroupSetCourseData(res));
    }
    static unsafeDecode(input) {
        return CreateGroupSetCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateGroupSetCourseDataParser.encode(data);
    }
    static schema() {
        return CreateGroupSetCourseDataParser.schema();
    }
}
